<template>
  <div>

        <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div
      style="box-shadow: 0px 2px 20px 0px #105c8e26"
      class="bg-white p-10 rounded"
    >


      <h3 class="text-lg font-semibold text-blues mb-2">Staff Upload Form</h3>
      <form @submit.prevent="handleSubmit" class="space-y-4"  ref="addRefs">
        <!-- Name -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label
              for="firstName"
              class="block text-sm font-medium text-gray-700 mb-1"
              >First Name</label
            >
            <input
              id="firstName"
              type="text"
              placeholder="First Name"
              v-model="firstName"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div>
            <label
              for="lastName"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Last Name</label
            >
            <input
              id="lastName"
              type="text"
              placeholder="Last Name"
              v-model="lastName"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <!-- Email -->
          <div>
            <label
              for="email"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Email ID</label
            >
            <input
              id="email"
              type="email"
              placeholder="Email ID"
              v-model="email"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>

          <div>
            <label
              for="countryCode"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Mobile Number</label
            >
            <div class="flex">
              <select
                id="country-form"
                v-model="countryCode"
                @change="setPhoneLength(countryCode)"
                required
                class="w-20 px-3 py-2 border border-gray-300 rounded"
              >
                <option value="" disabled>Select an option</option>
                <option
                  v-for="country in countryCodes"
                  :key="country.code"
                  :value="country.code"
                >
                  {{
                    countryCode === country.code
                      ? country.code
                      : `${country.name} (${country.code})`
                  }}
                </option>
              </select>
              <input
                type="tel"
                v-model="mobile"
                required
                class="w-full p-2 border border-gray-300 rounded"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                id="Phone_no"
                placeholder="Phone no*"
                :maxlength="max_length"
              />
            </div>
            <span class="text-xs font-normal" v-if="phone_max_length"
              >Please Enter
              <b>{{ phone_max_length }}</b>
              Digit Phone Number</span
            >
          </div>
        </div>

        <!-- Password Option -->

        <div class="grid grid-cols-1 sm:grid-cols-2 items-end gap-4">
          <div>
            <label class="block font-medium text-gray-700 mb-1">Password</label>
            <div class="flex gap-4 mb-2">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  id="passwordCustom"
                  value="custom"
                  v-model="passwordOption"
                  class="form-radio text-blue-500"
                />
                <span>Custom</span>
              </label>
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  id="passwordAuto"
                  value="auto"
                  v-model="passwordOption"
                  class="form-radio text-blue-500"
                />
                <span>Auto Generate</span>
              </label>
            </div>

            <div v-if="passwordOption === 'custom'">
              <label
                for="password"
                class="block text-sm font-medium text-gray-700 mb-1"
                >Custom Password</label
              >
              <input
                id="password"
                type="password"
                placeholder="Enter Password"
                v-model="password"
                class="w-full p-2 border border-gray-300 rounded"
                required
              />
            </div>

            <div v-if="passwordOption === 'auto'">
              <label
                for="password"
                class="block text-sm font-medium text-gray-700 mb-1"
                >Generated Password</label
              >
              <input
                id="password"
                type="text"
                :value="password"
                readonly
                class="w-full p-2 border border-gray-300 rounded bg-gray-100"
              />
            </div>
          </div>
          <div>
            <label
              for="selectField"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Role
            </label>
            <select
              v-if="rols"
              id="selectField"
              v-model="role"
              class="w-full p-2 border border-gray-300 rounded"
              required
            >
              <option value="" disabled selected>Select Role</option>
              <option v-for="rol in rols.filter(r => r.permission !== 'student')" :key="rol.id" :value="rol.id">
                {{ rol.permission }}
              </option>
            </select>
          </div>
        </div>

      

        <div class="flex justify-end">
          <button
            type="submit"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Submit
          </button>
        </div>
      </form>

        <!-- <div class="flex items-center justify-center pt-3 w-full">
          <div class="w-full border border-gray-400 h-0"></div>
          <div class="px-3 text-black">or</div>
          <div class="w-full border border-gray-400 h-0"></div>
        </div> -->


      <!-- <form @submit.prevent="handleSubmitcsv" class="space-y-4" ref="clearRef">
     
        <div class="flex flex-col gap-3 w-full">
          <div class="flex justify-between">
            <label for="attachments" class="text-left flex items-center"
              >Bulk Upload *
              <div class="relative group">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                    clip-rule="evenodd"
                  />
                </svg>
                <div
                  class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                >
                  Only CSV files in the sample format are allowed.
                </div>
              </div>
            </label>
            <div class="w-[20%] flex justify-center items-center">
              <a
                href="https://muonlms-api.galecta.com/media/uploaded_videos/staff_bulk_AYOoS57.csv"
                download
                class="w-full flex gap-1 items-center justify-center tooltip"
              >
                <img
                  src="@/assets/newd/download.png"
                  alt="download file"
                  class="w-4 h-4 object-contain"
                />
                <span class="tooltiptext text-xs w-full"> Sample File</span>
              </a>
            </div>
          </div>
          <input
            id="source"
            type="file"
            class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
            @change="inputchange"
            
          />
        </div>

        <div class="flex justify-end">
          <button
            type="submit"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Submit
          </button>
        </div>
      </form> -->

    </div>

    <div class="mt-10 overflow-x-auto">
      <h2 class="text-lg font-semibold mb-4">Submitted Data</h2>
      <table class="min-w-full divide-y divide-gray-200 border">
        <thead class="bg-blues">
          <tr>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              S.NO
            </th>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              First Name
            </th>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              Last Name
            </th>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              Email
            </th>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              Mobile
            </th>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              Role
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 bg-white">
          <tr v-for="(item, index) in submittedData" :key="index">
            <td class="px-4 py-2 text-sm">{{ (currentPage - 1) * 10 + index + 1 }}</td>
            <td class="px-4 py-2 text-sm">{{ item.first_name }}</td>
            <td class="px-4 py-2 text-sm">{{ item.last_name }}</td>
            <td class="px-4 py-2 text-sm">{{ item.email || "Na" }}</td>
            <td class="px-4 py-2 text-sm">
               {{ item.phone_number || "Na" }}
            </td>
            <td class="px-4 py-2 text-sm">{{ item.role||"Na" }}</td>
          </tr>
        </tbody>
      </table>

       <div
                class="pb-5 flex items-center justify-center"
              >
                <Pagination :totalPages="totalPages" @page-changed="getsubmit" />
               </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import countryCodeMixins from "@/mixins/countryCodeMixins";
import phoneLength from "@/mixins/phoneLength";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";


export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      countryCode: "+91",
      phone_max_length: "",
      mobile: "",
      passwordOption: "custom",
      password: "",
      role: "",
      max_length: 10,
      rols: [],
      submittedData:[],
      totalPages: 0, 
      messages: {
        text: "",
        type: "null",
      },
       currentPage: 1,
    };
  },

  components: {
    FlashMessage,
    Pagination,
  },

  mixins: [countryCodeMixins, phoneLength],
  watch: {
    passwordOption(newVal) {
      if (newVal === "auto") {
        this.password = this.generatePassword();
      } else {
        this.password = "";
      }
    },
  },
  computed: mapGetters(["userInfo"]),
  async created() {
    this.getrole();
    this.getsubmit(1);
  },
  mounted() {},
  methods: {

    handleSubmitcsv(el){

      let formData = new FormData();
      // formData.append("title", el.target.elements.file_title.value);
      // formData.append("description", el.target.elements.file_description.value);
      formData.append("file", el.target.elements.source.files[0]);

      axios
        .post(
          `${process.env.VUE_APP_API}/enrollement-bulk-csv-upload/?Key=${this.userInfo.token_key}`,
          formData
        )
        .then((response) => {
          if (response.data.status == 200) {
                 this.getsubmit(1);
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.clearRef.reset();
            }, 1500);
         
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    generatePassword() {
      return Math.random().toString(36).slice(-8);
    },
    getrole() {
      axios
        .get(
          `${process.env.VUE_APP_API}/permission-list/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.rols = response.data.data;
            // this.rols = response.data.data.filter(role => role.permission != 'student');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSubmit() {
      const beforeData = {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        custom_password: this.password,
        auto_generative_password: this.password,
        country_code: this.countryCode,
        phone_number: this.countryCode + " " + this.mobile,
        role: this.role,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/user/signup/?Key=${this.userInfo.token_key}`,
          beforeData
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };

              this.getsubmit(1);
              this.$refs.addRefs.reset();

                this.firstName = "";
                this.lastName = "";
                this.email = "";
                this.password = "";
                this.password = "";
                this.countryCode = "";
                this.countryCode = "";
                this.mobile = "";
                this.role = "";
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },
    getsubmit(number) {
       this.currentPage = number;
      axios
        .get(
          `${process.env.VUE_APP_API}/staff-enrollment-list/?Key=${this.userInfo.token_key}&page=${number}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
             this.totalPages = response.data.total_page;
            this.submittedData = response.data.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
/* tool tip  */
.tooltip {
  position: relative;
  display: inline-block;
  /* border-bottom: 1px dotted black; */
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 40%;
  /* background-color: #17469E; */
  /* color: #fff; */
  color: #17469e;
  text-align: center;
  border: 1px solid #17469e;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  bottom: -8px;
  left: 20px;
  z-index: 1;
}
.wrapper-class {
  max-width: 200px;
  word-wrap: break-word;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
